import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsEnvelope } from "react-icons/bs";
import { setEmailBoxCoordinates } from "../../redux/slices/emailBoxCoordinatesReducer";
import { setActiveCoordinate } from "../../redux/slices/activeCoordinateReducer";
import { FieldTypeEnum } from "../../constants/fieldTypeEnum";
import { ShowToast } from "../../utils/showToast";
import { ToastTypeEnum } from "../../constants/toastTypeEnum";

function EmailBoxButtonContainer({ documentBounding }) {
  const dispatch = useDispatch();
  const supportedFields = useSelector((state) => state.supportedFields.supportedFields);
  const activeSignatory = useSelector((state) => state.activeSignatory.activeSignatory);
  const activePageNumber = useSelector((state) => state.activePageNumber.activePageNumber);
  const emailBoxCoordinates = useSelector((state) => state.emailBoxCoordinatesReducer?.emailBoxCoordinates || []);
  const signatureCoordinates = useSelector((state) => state.signatureCoordinates.signatureCoordinates);
  const textBoxCoordinates = useSelector((state) => state.textBoxCoordinates.textBoxCoordinates);
  const dateCoordinates = useSelector((state) => state.dateCoordinates.dateCoordinates);
  const checkBoxCoordinates = useSelector((state) => state.checkBoxCoordinates.checkBoxCoordinates);
  const picklistCoordinates = useSelector((state) => state.picklistCoordinates.picklistCoordinates);

  const allCoordinates = [
    ...signatureCoordinates,
    ...textBoxCoordinates,
    ...dateCoordinates,
    ...checkBoxCoordinates,
    ...emailBoxCoordinates,
    ...picklistCoordinates,
  ];

  const isOverlapping = (newEle) => {
    return allCoordinates.some((coord) => {
      if (coord.pageId !== newEle.pageId) return false;
      return (
        newEle.x + 2 < coord.x + coord.width &&
        newEle.x + newEle.width - 2 > coord.x &&
        newEle.y + 2 < coord.y + coord.height &&
        newEle.y + newEle.height - 2 > coord.y
      );
    });
  };

  const pageDimensions = useSelector((state) => state.generalDocument?.pageDimensions);
  const canvasW = pageDimensions?.width || 595;
  const canvasH = pageDimensions?.height || 840;

  const onDragEnd = (event) => {
    try {
      const field = supportedFields.find((field) => field.type === FieldTypeEnum.EMAIL);
      const coordsLength = emailBoxCoordinates.length || 0;

      const pagex = event.pageX - documentBounding.left - field.width / 2;
    
      const pagey = event.pageY - documentBounding.top - field.height / 2;
      console.log('page y' + pagey);
      let newEle = {
        field_id: field.id,
        value: "",
        signatory_id: activeSignatory.id,
        user_index_id: activeSignatory.index,
        bgColor: activeSignatory.bgColor,
        name: `Email${coordsLength + 1}`,
        eleId: `emailEle${coordsLength}`,
        pageId: activePageNumber,
        x: pagex < 0 ? 0 : pagex > canvasW - field.width ? canvasW - field.width : pagex,
        y: pagey < 0 ? 0 : pagey > canvasH - field.height ? canvasH - field.height : pagey,
        width: field.width,
        height: field.height,
        isRequired: true,
        // writeBack: false,
        // updateFromSalesforce: false,
        mappingField: { label: "", value: "", type: "" }, // UI-only state, stripped before API call
        maxLength: 255,
        editable: true,
      };

      if(isOverlapping(newEle)) {
        ShowToast(ToastTypeEnum.ERROR, "Cannot place input on top of another input.");
        return;
       }


      dispatch(
        setEmailBoxCoordinates({
          emailBoxCoordinates: emailBoxCoordinates.concat(newEle),
        })
      );

      dispatch(
        setActiveCoordinate({
          activeCoordinate: newEle,
          isSelectionMode: true,
        })
      );
    } catch (e) {
      localStorage.setItem("unexpected-error", e.stack);
      window.location.href = "/unexpected-error";
      throw new Error(e.message);
    }
  };

  return (
    <button type="button" className="tool-btn" onDragEnd={onDragEnd} draggable>
      <BsEnvelope className="tool-icon" /> <p>Email</p>
    </button>
  );
}

export default EmailBoxButtonContainer;
